export default __webpack_public_path__ + "static/media/star2.46f3b053.mp3";